import { useCategoryOptions, useRoleOptions } from "../../hooks/dropdownOptions";

export const useFormConfig = () => {
  const categoryOptions = useCategoryOptions();
  const roleOptions = useRoleOptions();
  return {
    courseForm: {
      formTitle: "Course",
      initialFormData: {
        title: "",
        categoryId: null,
        roleId: null,
        publishDate: "",
        startDate: "",
        endDate: ""
      },
      fieldConfig: [ 
        {
          key: "title",
          label: "Course Title",
          type: "text",
          placeholder: "Enter Course Title",
          required: true,
          alphaOnly: true 
        },
        {
          key: "categoryId",
          label: "Category",
          type: "dropdown",
          options: categoryOptions,
          placeholder: "Select a Category",
          required: true,
        },
        {
          key: "roleId",
          label: "Role",
          type: "multiselect",
          options: roleOptions,
          placeholder: "Select a Role",
          required: true,
        },
        {
          key: "publishDate",
          label: " Scheduled Publish Date",
          type: "calendar",
          required: false,
          placeholder: "Select a Publish Date"
        },
        {
          key: "startDate",
          label: "Start Date",
          type: "calendar",
          required: true,
          placeholder: "Select a Start Date"
        },
        {
          key: "endDate",
          label: "End Date",
          type: "calendar",
          required: true,
          placeholder: "Select a End Date"
        }
      ],
    },
  };
};
